module.exports = __webpack_public_path__ + "img/i1.49a66b79.jpeg";